import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { ArrowLeft } from "lucide-react";

export default function ReadmePage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Button variant="ghost" onClick={() => navigate("/")} className="gap-2 mb-6"><ArrowLeft className="w-4 h-4" /> Back</Button>
        <Card>
          <CardHeader>
            <CardTitle className="font-display text-xl">About this Prototype</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6 text-sm leading-relaxed text-foreground">
            <div>
              <h3 className="font-display font-semibold mb-2">What it is</h3>
              <p className="text-muted-foreground">
                Synaptick Clarity Layer V2 is a decision-stage integration tool. It connects with
                partner platforms like Educrib to help learners turn uncertainty into a practical
                Clarity Brief with search filters, reality snapshots, and next actions.
              </p>
            </div>
            <Separator />
            <div>
              <h3 className="font-display font-semibold mb-2">What it does NOT do</h3>
              <ul className="space-y-1 text-muted-foreground">
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />Does not recommend specific institutions by name.</li>
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />Does not provide official admissions or career advice.</li>
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />Does not require login or store personal identifiers by default.</li>
              </ul>
            </div>
            <Separator />
            <div>
              <h3 className="font-display font-semibold mb-2">Readiness computation</h3>
              <p className="text-muted-foreground">
                Readiness is computed from concept-check answers and self-reported confidence.
                High: score 66%+ and confidence 3+. Medium: 33-65% or confidence 2-3.
                Low: below 33% or confidence under 2.
              </p>
            </div>
            <Separator />
            <div>
              <h3 className="font-display font-semibold mb-2">Partner integration</h3>
              <p className="text-muted-foreground">
                Partners send context via URL query parameters (Mode A) or server-to-server
                webhook (Mode B with X-PARTNER-SECRET header). The tool produces a Decision
                Payload and redirect URL with pre-filled filters.
              </p>
            </div>
            <Separator />
            <div>
              <h3 className="font-display font-semibold mb-2">Configuration</h3>
              <ul className="space-y-1 text-muted-foreground">
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />ADMIN_PASSCODE: admin dashboard access</li>
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />PARTNER_SECRET: webhook authentication</li>
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />EMERGENT_LLM_KEY: AI brief generation</li>
                <li className="flex items-start gap-2"><span className="w-1 h-1 rounded-full bg-muted-foreground mt-2 shrink-0" />MONGO_URL: session and analytics storage</li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
